import { VIEW } from "../../constants/view.constants";
import { WIZARD_STEPS } from "../../constants/wizardSteps.constants";

export const initialState = {
    view: VIEW.WIZARD,
    currentStep: WIZARD_STEPS.NAME_YOUR_AGENT,
    previousStep: null,
    user: null,
    loading: false,
    error: null,
    expandedMode: false,
    wizardData: {
        chatbotName: "",
        skillDescription: "",
        files: [],
        chatbotId: "",
        skillId: "",
        chatbotUrl: "",
        clientId: "",
        prefilledFromAdmin: false,
        currentAgents: 0,
        wizardToken: null,
        userDetails: {
            firstName: "",
            lastName: "",
            email: "",
            company: ""
        },
        emailVerification: {
            isVerified: false,
            codeSent: false,
            loading: false,
            error: null,
            verificationCode: '',
            sessionId: null,
            isAdminPanelUser: false
        }
    }
};

export const reducer = (state, action) => {
    switch (action.type) {
        case "SET_VIEW":
            return {
                ...state,
                view: action.view
            };
        case "SET_CURRENT_STEP":
            return {
                ...state,
                currentStep: action.step
            };
        case "SET_PREVIOUS_STEP":
            return {
                ...state,
                previousStep: action.step
            };
        case "SET_USER":
            return {
                ...state,
                user: action.user
            };
        case "SET_LOADING":
            return {
                ...state,
                loading: action.loading
            };
        case "SET_ERROR":
            return {
                ...state,
                error: action.error
            };
        case "TOGGLE_EXPANDED_MODE":
            return {
                ...state,
                expandedMode: !state.expandedMode
            };
        case "SET_EXPANDED_MODE":
            return {
                ...state,
                expandedMode: action.expanded
            };
        case "UPDATE_WIZARD_DATA":
            return {
                ...state,
                wizardData: {
                    ...state.wizardData,
                    ...action.data
                }
            };
        case "UPDATE_EMAIL_VERIFICATION":
            return {
                ...state,
                wizardData: {
                    ...state.wizardData,
                    emailVerification: {
                        ...state.wizardData.emailVerification,
                        ...action.data
                    }
                }
            };
        case "RESET_WIZARD":
            return {
                ...state,
                currentStep: WIZARD_STEPS.NAME_YOUR_AGENT,
                wizardData: {
                    chatbotName: "",
                    skillDescription: "",
                    files: [],
                    chatbotId: "",
                    skillId: "",
                    chatbotUrl: "",
                    clientId: "",
                    prefilledFromAdmin: false,
                    currentAgents: 0,
                    wizardToken: null,
                    userDetails: {
                        firstName: "",
                        lastName: "",
                        email: "",
                        company: ""
                    },
                    emailVerification: {
                        isVerified: false,
                        codeSent: false,
                        loading: false,
                        error: null,
                        verificationCode: '',
                        sessionId: null,
                        isAdminPanelUser: false
                    }
                },
                error: null
            };
        default:
            return state;
    }
};
